import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { optimizeImageUrl } from "../../utils/images";

const HERO_IMAGE = optimizeImageUrl(
  "https://res.cloudinary.com/dirgb6nie/image/upload/v1775254817/e42d39e0-5f7a-4201-bad7-bc1e7e5b1054_yd1ycl.jpg",
  { width: 1800 }
);

export default function Hero() {
  const [visible, setVisible] = useState(false);
  useEffect(() => { const t = setTimeout(() => setVisible(true), 80); return () => clearTimeout(t); }, []);

  const anim = (delay) => ({
    style: { transitionDelay: delay },
    className: `transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`,
  });

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url('${HERO_IMAGE}')` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
      </div>
      <div className="absolute top-0 right-0 w-1 h-full bg-brand-red/50" />

      <div className="relative z-10 max-w-7xl mx-auto px-3 sm:px-5 lg:px-6 pt-28 pb-8 sm:pb-24 w-full">
        <div className="max-w-4xl">
          <div {...anim("100ms")} className={`flex items-center gap-3 mb-6 ${anim("100ms").className}`} style={anim("100ms").style}>
            <span className="w-8 h-px bg-brand-red" />
            <span className="font-body text-xs tracking-[0.3em] text-white/60 uppercase">Luxury Fragrance House</span>
          </div>

          <h1
            className={`font-display font-light text-white leading-[0.98] tracking-[0.015em] mb-6 max-w-[14ch] transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
            style={{ fontSize: "clamp(3rem, 7vw, 6.4rem)", transitionDelay: "200ms" }}
          >
            Timeless<br />
            <span className="italic text-brand-red">Fragrances.</span><br />
            Infinite Confidence
          </h1>

          <p
            className={`font-body text-base sm:text-lg md:text-xl text-white/65 mb-10 max-w-2xl leading-relaxed transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
            style={{ transitionDelay: "300ms" }}
          >
            A luxury perfume brand curating timeless fragrances that embody confidence, sophistication, and individuality.
          </p>

          <div
            className={`flex flex-wrap items-center gap-4 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
            style={{ transitionDelay: "450ms" }}
          >
            <Link to="/products" className="btn-primary group">
              Shop Now
              <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-200" />
            </Link>
            <Link to="/about" className="inline-flex items-center gap-2 px-7 py-3.5 border border-white/40 text-white font-body font-medium text-sm rounded-sm hover:border-white hover:bg-white/10 transition-all duration-300">
              Our Story
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
